var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4141 11.9844C25.1562 11.2812 25.1562 10.0703 24.4141 9.32812L16.1719 1.08594C15.8594 0.773438 15.2734 0.5 14.8438 0.5H12.9297L23.125 10.6562L13.7891 19.9531C14.5312 20.6953 15.7422 20.6953 16.4453 19.9531L24.4141 11.9844ZM19.4141 11.9844C20.1562 11.2812 20.1562 10.0703 19.4141 9.32812L11.1719 1.08594C10.8594 0.773438 10.2734 0.5 9.84375 0.5H1.875C0.820312 0.5 0 1.35938 0 2.375V10.3828C0 10.8125 0.234375 11.3984 0.546875 11.7109L8.78906 19.9531C9.17969 20.3438 9.64844 20.5 10.1172 20.5C10.625 20.5 11.0938 20.3438 11.4453 19.9531L19.4141 11.9844ZM18.125 10.6562L10.1172 18.625L1.875 10.3828V2.375H9.84375L18.125 10.6562ZM5.625 4.25C4.57031 4.25 3.75 5.10938 3.75 6.125C3.75 7.17969 4.57031 8 5.625 8C6.64062 8 7.5 7.17969 7.5 6.125C7.5 5.10938 6.64062 4.25 5.625 4.25Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBogo);
export default __webpack_public_path__ + "static/media/bogo.0f3a6a7b.svg";
export { ForwardRef as ReactComponent };